/* eslint-disable @typescript-eslint/no-explicit-any */
import { capitalize } from '../../utils/string-utils';

/**
 * Transform error keys by given mapping object
 * @example
 * mapErrors({}, )
 * @param apiErrors {} error object structure returned from api
 * @param errorKeysMap = {} error mapping hash used for transformation
 * @returns {{}} Transformed error object
 */
export function mapErrors(apiErrors: any, errorKeysMap: any = {}) {
  const formErrors: any = {};
  for (const apiErrorKey of Object.keys(apiErrors)) {
    const mappedKey = errorKeysMap[apiErrorKey];
    const errorValue = apiErrors[apiErrorKey];
    if (mappedKey) {
      formErrors[mappedKey] = errorValue.message;
    } else {
      formErrors[apiErrorKey] = errorValue.message;
    }
  }
  return formErrors;
}

/**
 * Flattens validations error keys:
 * @example
 * From:
 * {
 *   serviceProvider: {
 *     base: {
 *       message: 'Some Error'
 *     },
 *     name: {
 *       message: 'Name is required'
 *     }
 *   }
 * }
 *
 * To:
 * {
 *   serviceProvider: {
 *     message: 'Some Error'
 *   },
 *   serviceProviderName: {
 *     message: Name is required'
 *   }
 * }
 * @param errors {} - source errors object
 * @returns {} - flattened errors object
 */
export function flattenErrors(errors: any = {}) {
  const mappedErrors: any = {};
  for (const entityKey of Object.keys(errors)) {
    const errorEntity = errors[entityKey];
    for (const attrKey of Object.keys(errorEntity)) {
      const mappedKey = entityKey === 'base' ? attrKey : entityKey + capitalize(attrKey);
      mappedErrors[mappedKey] = errors[entityKey][attrKey];
    }
  }
  return mappedErrors;
}
